import React from "react";
import { LegalLayout } from "@/components/LegalLayout";
import { privacySections } from "@/content/legal";
import { useLang } from "@/lib/i18n";

export default function PrivacyPage() {
  const { t } = useLang();
  const host = window.location.hostname;
  return (
    <LegalLayout
      testId="privacy-page"
      title={t("privacyPolicy")}
      updated={t("legalUpdated")}
      sections={privacySections(host)}
    />
  );
}
